<template>
	<div>
		<PagesHeading :path2="oneNew.title" />
		<div class="row m-0 d-flex justify-content-center">
			<div class="col-10">
				<div id="new" class="row" :class="{ 'loading-app-style': loading }">
					<div v-if="loading" class="d-flex align-items-center justify-content-center py-5">
						<div class="loader"></div>
					</div>
					<div v-else class="col-md-8 py-5">
						<div class="main-img">
							<div class="img-container">
								<img @load="loadingImg = false" v-show="!loadingImg" :src="oneNew.primaryImage.url"
									class="img-fluid cover">
								<div v-if="loadingImg" class="d-flex align-items-center justify-content-center py-5">
									<div class="loader"></div>
								</div>
							</div>
							<span class="bottom-right">
								<i class="fas fa-calendar-alt mx-2"></i>
								{{ oneNew.date.split(' ')[0] }}
							</span>
							<h3 v-if="!loadingImg" class="news-title my-1 mx-2 bottom-left"
								style="box-shadow: 0 1px 0 rgba(0, 0, 0, 0), 0 2px 0 rgba(255, 255, 255, 0);">{{ oneNew.title }}
							</h3>
						</div>
						<p v-html="news.content" class="description d-block my-4 mb-5 px-2"></p>
						<!-- <Carousel :autoplay="true" :autoplayTimeout="3000" :loop="true" :rtl="true" :responsive="responsive"
							:nav="false" :center="true">
							<div class="px-2" v-for="(image, index)  in oneNew.images" :key="index">
								<a class="d-flex justify-content-center" @click="show(image.url)">
									<img :id="index" style="width:100%;max-width:300px" :src="image.url"
										class="same-height cover img-fluid rounded">
								</a>
							</div>
						</Carousel> -->
						<Hooper :settings="hooperSettings">
							<Slide class="px-2" v-for="(image, index)  in oneNew.images" :key="index">
								<a class="d-flex justify-content-center" @click="show(oneNew.images,index)">
									<img :id="index" style="width:100%;max-width:300px" :src="image.url"
										class="same-height cover img-fluid rounded">
								</a>
							</Slide>
							<Pagination  slot="hooper-addons"></Pagination>
						</Hooper>
					</div>
					<div v-if="!loading" class="col-md-4 col-12 py-5 ">
						<h4 class="mb-4 mt-4 related-title">{{ $t('newsPage.related-news') }}</h4>
						<div v-for="(newTitle, i) in AllNew" :key="i" class="card mx-0 mx-lg-3 mb-3">
							<router-link :to="{ name: 'news-view', params: { slug: newTitle.slug } }">
								<div class="card-body">
									<h5 class="card-title">{{ newTitle.title }}</h5>
									<p class="card-link">{{ $t('common.read-more') }}</p>
								</div>
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<lightbox
				:visible="visible"
				:index="index"
				:imgs="img"
				@hide="hide() "
			>
			</lightbox>
		</div>
	</div>
</template>
<script>
import { Hooper, Slide, Pagination } from 'hooper';
import 'hooper/dist/hooper.css';
// import Carousel from 'vue-owl-carousel';
import lightbox from 'vue-easy-lightbox'
import { mapState, mapActions } from 'vuex';
import PagesHeading from '@/components/PagesHeading.vue';
export default {
	components: {
		// Carousel,
		lightbox,
		Hooper,
		Slide,
		Pagination,
		PagesHeading
	},
	data() {
		return {
			loading: true,
			index: 0,
			responsive: {
				0: { items: 1 },
				600: { items: 2 },
				1000: { items: 3 },
			},
			visible: false,
			img: '',
			loadingImg: true,
			hooperSettings: {
				pagination: 'no',
				playSpeed: 3000,
				infiniteScroll: true,
				itemsToSlide: 1,
				itemsToShow: 2,
				autoPlay: true,
				breakpoints: {
					100: {
						itemsToShow: 1,
						centerMode: true
					},
					800: {
						itemsToShow: 2
					},
					1200: {
						itemsToShow: 3
					}
				}
			}
		}
	},
	computed: {
		...mapState({
			news: state => state.news.news
		}),
		oneNew() {
			if (this.news[0]) {
				return	this.news.find(t => t.slug === this.$route.params.slug);
			} else {
				return '';
			}
		},
		AllNew() {
			return this.news.filter(t => t.slug !== this.$route.params.slug);
		}
	},
	methods: {
		...mapActions('news', ['fetchNews']),
		fetch() {
			this.loadingImg = true;
			if (!this.news[0]) {
				this.fetchNews()
					.finally(() => {
						this.loading = false;
					});
			} else {
				this.loading = false;
			}
		},
		hide() {
			this.visible = false;
		},
		show(images, i) {
			const urls = [];
			for (let i = 0; i < images.length; i++) { 
				urls.push(images[i].url);
			}
			this.index = i;
			this.img = urls;
			this.visible = true;
		}
	},
	created() {
		this.fetch();
	},
	watch: {
		$route(to, from) {
			this.fetch();
		}
	}
}
</script>
<style scoped>
body {
	background-color: #fff;
}

.custom-carousel .VueCarousel-wrapper {
	display: flex;
	gap: 15px;
	/* Adjust spacing between items */
}

.main-img {
	position: relative;
	text-align: center;
	color: white;
}

img {
	width: 100%;
}

.img-container {
	width: 100%;
}

.top-left {
	position: absolute;
	top: 8px;
	left: 16px;
	text-align: start;
}

.bottom-left {
	position: absolute;
	width: 70%;
	bottom: 8px;
	left: 5%;
	text-align: start;
}

.news-detail i {
	color: #f9a61a;
}

.news-detail h2 {
	color: #292728;
	font-weight: 700;
}

img.same-height {
	height: 200px;
}

.cover {
	object-fit: cover;
}

.overlay {
	display: inline-block;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0.65) 100%);
}

.overlay img {
	position: relative;
	z-index: -1;
	display: block;
}

.card {
	/* background-color: #FC9F2C; */
	border: 0px;
	width: 100% !important;
	border-left: 5px solid #292929;
	transition: all 0.5s ease, border-left 0.5s ease;
}

.card:hover {
	border-left: 5px solid #FC9F2C;
}

.card-body {
	padding-top: 0px;
	padding-bottom: 0px;
}

.card-title {
	color: #292929;
}

.card-text {
	color: #292929;
}

.card-link {
	color: #292929;
}

.card-link:hover {
	color: #FC9F2C;
}

a:hover {
	text-decoration: none;
}

.more-product {
	font-size: 2rem;
	color: #FCAD4D;
	margin-top: 30%;
}

html[dir="rtl"] .top-left {
	position: absolute;
	top: 8px;
	right: 5px;
	left: 10rem;
}

.bottom-right {
	bottom: 30px;
	right: 5%;
	position: absolute;
}

html[dir="rtl"] .bottom-right {
	width: 20%;
	bottom: 30px;
	right: 75%;
	position: absolute;
}

html[dir="rtl"] .bottom-left {
	width: 60%;
	position: absolute;
	bottom: 8px;
	right: 5%;
}

html[dir="rtl"] .description {
	text-align: right;
}

html[dir="rtl"] .card-body {
	text-align: right;
}

html[dir="rtl"] .card-body {
	text-align: right;
}

html[dir="rtl"] .card {
	border-right: 5px solid #292929;
	border-left: none;
}

html[dir="rtl"] .card:hover {
	border-right: 5px solid #FC9F2C;
	border-left: none;
}

html[dir="rtl"] .related-title {
	text-align: right;
}

</style>
